import { render, staticRenderFns } from "./addEmailModal.vue?vue&type=template&id=20641af6&scoped=true&"
import script from "./addEmailModal.vue?vue&type=script&lang=js&"
export * from "./addEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./addEmailModal.vue?vue&type=style&index=0&id=20641af6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20641af6",
  null
  
)

export default component.exports